module.exports = __webpack_public_path__ + "img/RB4420.fe1450af.jpg";